export function mobileNav() {
    const body = $("body");
    const btnMenu = $(".btn-menu");
    const mainNav = $(".main-menu");
    const mainNavItems = mainNav.find(".menu-item-has-children");
    const arrowButton = `<button class='opener'>
                            <svg class="plus" width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.298828 7.11096V4.91096H4.03883V0.928955H6.28283V4.91096H10.0008V7.11096H6.28283V11.071H4.03883V7.11096H0.298828Z" fill="#002459"/>
                            </svg>
                            <svg class="minus" width="10" height="4" viewBox="0 0 10 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.298828 3.0999V0.899902H4.03883H6.28283H10.0008V3.0999H6.28283H4.03883H0.298828Z" fill="#002459"/>
                            </svg>
                         </button>`;
    let activeMenuItem;

    //burger
    btnMenu.on("click", function (e) {
        let $this = $(this);
        if (!$this.hasClass("open")) {
            $this.addClass("open");
            body.addClass("menu-opened");
        } else {
            $this.removeClass("open");
            body.removeClass("menu-opened");
        }
        e.preventDefault();
    });

    //append arrow and back buttons
    mainNavItems.each((i, item) => {
        const menuList = $(item).find(" > .sub-menu");
        if (!$(item).find(".opener").length) {
            $(arrowButton).insertBefore(menuList, null);
        }
    });

    //close menu
    function closeDropdown(e) {
        if (!mainNavItems.has(e.target).length > 0) {
            mainNavItems.removeClass("active").find("ul").slideUp(500);
            window.removeEventListener("click", closeDropdown);
        }
    }


    //show/hide menu
    $(document).on("click", ".main-menu .opener", function (e) {
        const target = $(e.target);

        if (target.closest(".opener").length) {
            activeMenuItem = target.closest(".opener").parent();
            if (window.innerWidth < 1024) {
                if (!activeMenuItem.hasClass("active")) {
                    activeMenuItem.siblings().removeClass("active");
                    activeMenuItem.parent().find(".sub-menu").slideUp();
                    activeMenuItem.addClass("active").find(".sub-menu").slideDown();
                } else {
                    activeMenuItem.removeClass("active").find(".sub-menu").slideUp();
                }
            }
            if (window.innerWidth > 1023 && body.hasClass("touch")) {
                if (!activeMenuItem.hasClass("active")) {
                    activeMenuItem.siblings().removeClass("active");
                    activeMenuItem.addClass("active").find(".sub-menu").fadeIn();
                } else {
                    activeMenuItem.removeClass("active").find(".sub-menu").fadeOut();
                }
                window.addEventListener("click", closeDropdown);
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js